import UserDigest from "../../types/core/UserDigest";
import { SystemFileType } from "../enums/SystemFileType";
import { SystemFileVersion } from "../enums/SystemFileVersion";

class File {
    get compositeId(): string {
        return `${this.badge}-${this.id}`;
    }

    id: number;
    fileId: number;
    folderId: number;
    schoolId: number;
    code: string;
    name: string;
    fileName: string;

    fileType: SystemFileType;
    parentFileType: SystemFileType;
    fileHash: string;
    storageToken: string;

    version: SystemFileVersion;
    status: string;
    message: string;

    childFolderCount: number;
    childSOFCount: number;
    childTDFCount: number;
    childDOFCount: number;
    childArchiveCount: number;
    studentTotalField: number;
    subjectTotalField: number;
    classTotalField: number;

    timetableFieldId: number;

    linkedFiles: string[];

    published: boolean;
    archive: boolean;
    recycled: boolean;
    isFolder: boolean;
    badge?: string;
    selected: boolean;
    typeDisplay: string;

    publishDate: Date;
    createdBy: number;
    createdOn: Date;
    editedBy: number;
    editedOn: Date;
    recycledBy: number;
    recycledByUser: UserDigest;
    recycledOn: Date;

    constructor(data: Partial<File>) {
        Object.assign(this, data);

        this.isFolder = this.fileType === "Folder";

        this.createdOn = this.createdOn?.toDate();
        this.editedOn = this.editedOn?.toDate();
        this.recycledOn = this.recycledOn?.toDate();
        this.publishDate = this.publishDate?.toDate();

        if (this.recycledByUser)
            this.recycledByUser = new UserDigest(this.recycledByUser);
    }
}

export default File;
